import pushStateHistoryUtil from 'utils/history/push-state'
import getPathnameLocationUtil from 'utils/location/get-pathname'

export default function updateHandleUrlProductUtil ({ handle }) {
  const pathname = getPathnameLocationUtil()
  const [baseUrl, queryString] = pathname.split('?')
  const segments = baseUrl.split('/')

  segments[segments.length - 1] = handle

  let updatedUrl = segments.join('/')
  if (queryString) {
    updatedUrl += '?' + queryString
  }

  pushStateHistoryUtil(updatedUrl)
}
